import * as React from "react"
import { Icon } from "@oysterhr/ui"
import { OysterIcon } from "@oysterhr/icons"
import classNames from "classnames"

interface ClickableTooltipProps {
  onClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
  iconClassnames?: string
  icon?: OysterIcon
  children?: React.ReactNode
}

export const ClickableTooltip = ({
  onClick,
  children,
  icon,
  iconClassnames,
}: ClickableTooltipProps) => {
  return (
    <div
      data-testid="clickable-tooltip"
      className="flex cursor-pointer items-center"
      onClick={e => {
        e.preventDefault()
        e.stopPropagation()
        onClick(e)
      }}
    >
      {!children && (
        <Icon
          name={icon || "InfoCircle"}
          className={classNames(
            iconClassnames || "text-primary-base hover:text-primary-darken-100",
          )}
        />
      )}
      {children}
    </div>
  )
}
